import { Outlet } from 'react-router-dom';
import { Rail } from './Rail';
import { TopBar } from './TopBar';

export function AppShell() {
  return (
    <div className="shell">
      <Rail />
      <div className="canvas">
        <TopBar />
        <Outlet />
      </div>
    </div>
  );
}
